module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAGFBMVEUAAABicZlicZlicZlicZlicZlicZlicZlfxV3pAAAAB3RSTlMAHOZJw7XE9qp5PQAAAEVJREFUGNNjwA/cy8tLoEyjAiCnjF0ZzFEvBJHiRWBOeakAAwNjeDmEAwGkcQqBZhGnDKiQctMwOeoQdhHEpxCOMr6AAQCmkzy1bzQVuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_order.png
// module id = 4i+g
// module chunks = 9